import {mapValues, omitBy, isNil} from "lodash";

export function stringifyObjectValues(obj: {[key: string]: any}): {[key: string]: string} {
  return mapValues(omitBy(obj, isNil), val => val.toString());
}
